import React from 'react';
import { keyLabel, MIN_SEMITONES, MAX_SEMITONES } from './keyShift';
import './KeyControl.css';

/**
 * Key: − value + (2026-09-26). One semitone per tap, tempo unchanged; tapping
 * the value returns to the original key. Shared by the teacher's track strip
 * and the family Songs page, so a student practises at home in the key their
 * lesson used when a teacher shows them how. Hidden entirely where the browser
 * cannot do it (keyAvailable false) rather than offering a dead control.
 */
// `label` (pass 3 F5): the Lesson Dashboard's strip says "Track key" so it
// never shares a word with the warm-up strip's "Warm-up key".
const KeyControl = ({ player, label = 'Key' }) => {
	if (!player || !player.keyAvailable) return null;
	const n = player.semitones || 0;
	return (
		<div className="tk" role="group" aria-label={label}>
			<span className="tk__label">{label}</span>
			<button
				type="button"
				className="tk__btn"
				aria-label="Down a semitone"
				disabled={n <= MIN_SEMITONES}
				onClick={() => n > MIN_SEMITONES && player.setKey(n - 1)}>
				<i className="fa-sharp fa-solid fa-minus" aria-hidden="true" />
			</button>
			<button
				type="button"
				className={`tk__value${n ? ' is-shifted' : ''}`}
				aria-label={n ? `Key ${keyLabel(n)} semitones. Reset to original` : 'Original key'}
				onClick={() => n && player.setKey(0)}>
				{keyLabel(n)}
			</button>
			<button
				type="button"
				className="tk__btn"
				aria-label="Up a semitone"
				disabled={n >= MAX_SEMITONES}
				onClick={() => n < MAX_SEMITONES && player.setKey(n + 1)}>
				<i className="fa-sharp fa-solid fa-plus" aria-hidden="true" />
			</button>
		</div>
	);
};

export default KeyControl;
